export const FIRST_LIMIT_CONSTANT = 11
export const LIMIT_CONSTANT = 12
export const MAX_SIZE_DOCUMENT = '10 MB'


// used for load more all ideas  
export const PAGE_SIZE = 400;
export const LOAD_MORE_SIZE = 400;

export const CHALLENGE_PAGE_SIZE = 20;
export const CHALLENGE_LOAD_MORE_SIZE = 20;
